/**
 * Header XP block (specs/xp-and-ranks AC-12/13, design "Header Explorations" variant 1a):
 * the avatar wears a progress ring showing progress through the current level, an
 * "LV N" pill hangs under it, and the rank badge sits beside it.
 * Before data loads (or errored/guest): ring at 0%, no pill, no rank block.
 */

import React from 'react';
import { useAvatarContext } from '../../../avatars/contexts/AvatarContext';
import type { DisplayAvatarId } from '../../../avatars/types/avatar.types';
import { useXpSummary } from '../../hooks/useXpSummary';
import { useSelfRank } from '../../hooks/useSelfRank';
import { getXpProgress } from '../../helpers/rankRegistry.helper';
import { XpHeaderClusterView } from './XpHeaderClusterView';

export interface XpHeaderClusterProps {
  onAvatarPress: () => void;
  /** Opens the Rank Ladder (specs/rank-ladder). Omitted → the rank block is not pressable. */
  onRankPress?: () => void;
  testID?: string;
}

export const XpHeaderCluster: React.FC<XpHeaderClusterProps> = ({ onAvatarPress, onRankPress, testID }) => {
  const { currentAvatarId, currentAvatarConfig } = useAvatarContext();
  const { data } = useXpSummary();
  // Level + ring stay XP-based; the rank badge is coin-based and comes from the coin store so it
  // updates on coin gains that award no XP (specs/coin-based-ranks).
  const { rank } = useSelfRank();

  return (
    <XpHeaderClusterView
      level={data?.level ?? null}
      progress={data ? getXpProgress(data.xpIntoLevel, data.xpForLevel) : 0}
      rankName={rank?.name ?? null}
      rankBadge={rank?.badge ?? null}
      avatarId={(currentAvatarId ?? null) as DisplayAvatarId | null}
      avatarConfig={currentAvatarConfig}
      onAvatarPress={onAvatarPress}
      onRankPress={onRankPress}
      testID={testID}
    />
  );
};
